"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTracking = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var event_tracking_behavior_adapter_1 = require("@al/event-tracking-behavior-adapter");
var event_tracking_sensor_analytics_1 = require("@al/event-tracking-sensor-analytics");
var EventTracking = /** @class */ (function () {
    function EventTracking(observableService, behaviorService, saService, applicationExecutor, routeStackService, sessionService, transformFieldsService, adjustTimeService, localStoreService, sessionStoreService, activeTabService, visibilityEventService, visibilityEventObserver, v4EventOrderBucket, saEventOrderBucket, leaveOpsService, exposeService) {
        this.observableService = observableService;
        this.behaviorService = behaviorService;
        this.saService = saService;
        this.applicationExecutor = applicationExecutor;
        this.routeStackService = routeStackService;
        this.sessionService = sessionService;
        this.transformFieldsService = transformFieldsService;
        this.adjustTimeService = adjustTimeService;
        this.localStoreService = localStoreService;
        this.sessionStoreService = sessionStoreService;
        this.activeTabService = activeTabService;
        this.visibilityEventService = visibilityEventService;
        this.visibilityEventObserver = visibilityEventObserver;
        this.v4EventOrderBucket = v4EventOrderBucket;
        this.saEventOrderBucket = saEventOrderBucket;
        this.leaveOpsService = leaveOpsService;
        this.exposeService = exposeService;
        this.v4init = false;
        this.saInit = false;
        // 标记埋点工具是否开始生效
        this.effective = false;
        this.pendingInvokes = [];
        this.tracker = {
            behavior: this.behaviorService,
            sa: this.saService,
        };
    }
    EventTracking.prototype.invoke = function (methodKey, data) {
        var _this = this;
        var extra = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            extra[_i - 2] = arguments[_i];
        }
        var result = {
            storeName: "",
            behavior: {},
            sa: {},
        };
        if (!data) {
            return result;
        }
        Object.keys(data).forEach(function (key) {
            var _a;
            var k = key;
            var c = data[k];
            if (c && _this.tracker[k]) {
                // @ts-expect-error 可能传递多个参数
                result[k] = (_a = _this.tracker[k])[methodKey].apply(_a, __spreadArray([c], extra, false));
            }
        });
        return result;
    };
    EventTracking.prototype.asyncInitial = function (storeName, userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.init(storeName)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sessionService.init(userId)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.leaveOpsService.makePrevRouteLeave()];
                    case 3:
                        _a.sent();
                        this.applicationExecutor.setReady(true);
                        this.effective = true;
                        this.executePendingInvokes();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventTracking.prototype.init = function (trackerConfig) {
        var _a = trackerConfig.common, localTimeService = _a.localTimeService, rest = __rest(_a, ["localTimeService"]);
        this.config = {
            storeName: trackerConfig.storeName,
            common: trackerConfig.common,
        };
        if (trackerConfig.behavior) {
            this.config.behavior = __assign({}, trackerConfig.behavior);
            if (trackerConfig.behavior.v4) {
                this.v4init = true;
                this.config.behavior.v4 = __assign(__assign({}, trackerConfig.behavior.v4), rest);
            }
        }
        if (trackerConfig.sa) {
            this.saInit = true;
            this.config.sa = __assign(__assign(__assign({}, trackerConfig.sa), rest), { userId: "".concat(rest.userId || "") });
        }
        this.applicationExecutor.setEnabled(true);
        this.adjustTimeService.init(localTimeService);
        this.sessionStoreService.init(trackerConfig.storeName, "trackingSessionStore");
        this.localStoreService.init(trackerConfig.storeName, "trackingLocalStore");
        this.activeTabService.setCurrentToActive();
        this.exposeService.setRootMargin(this.config.intersectionRootMargin);
        this.asyncInitial(trackerConfig.storeName, rest.userId);
        this.visibilityEventService.monitor();
        this.visibilityEventService.subscribe(this.visibilityEventObserver);
        this.invoke("init", this.config);
        this.initRouteHooks(this.config);
        return this;
    };
    EventTracking.prototype.updateCommonConfig = function (conf) {
        var data = {};
        if (this.v4init) {
            data.behavior = {
                v4: __assign({}, conf),
            };
        }
        if (this.saInit) {
            data.sa = __assign({}, conf);
        }
        this.updateSdkConfig(data);
    };
    EventTracking.prototype.updateIntersectionRootMargin = function (rootMargin) {
        this.exposeService.setRootMargin(rootMargin);
    };
    EventTracking.prototype.setSdkConfig = function (config) {
        this.invoke("setSdkConfig", config);
    };
    EventTracking.prototype.updateSdkConfig = function (config) {
        this.invoke("updateSdkConfig", config);
    };
    EventTracking.prototype.setPageConfig = function (config) {
        var _this = this;
        // setPageConfig 调用 updateRouteInfo 会更新路由信息，需要重置应用 ready 状态为 false，
        // 这样业务可以按同步代码的方式调用 setPageConfig 和 enter，且保证 screenNum, page_id 等值是正确的
        this.delayedInvoke(function () {
            _this.applicationExecutor.setReady(false);
            _this.invoke("setPageConfig", config);
            _this.updateRouteInfo(config);
        });
    };
    EventTracking.prototype.getPageConfig = function () {
        var _this = this;
        return this.delayedInvoke(function () {
            return _this.invoke("getPageConfig", {
                behavior: {},
                sa: {},
            });
        });
    };
    EventTracking.prototype.enter = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.routeStackService.addByType(event_tracking_core_1.RouteType.Change);
                    this.invoke("enter", data);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.activityEnter = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.routeStackService.addByType(event_tracking_core_1.RouteType.Change);
                    this.invoke("activityEnter", data);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.leave = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.routeStackService.leave();
                    this.invoke("leave", data);
                    this.whenLeave();
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.click = function (data, event) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.invoke("click", data, event);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.activityClick = function (data, event) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.invoke("activityClick", data, event);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.popClick = function (data, event) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.invoke("popClick", data, event);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.popView = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                var sa, behavior, rest, finalData;
                return __generator(this, function (_a) {
                    if (data) {
                        sa = data.sa, behavior = data.behavior, rest = __rest(data, ["sa", "behavior"]);
                        finalData = __assign({}, rest);
                        if (sa) {
                            finalData.sa = __assign(__assign({}, sa), { event: event_tracking_sensor_analytics_1.EventType.PopView });
                        }
                        if (behavior) {
                            finalData.behavior = behavior;
                        }
                        this.exposeService.processManualExpose(finalData);
                    }
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.expose = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (data) {
                        this.exposeService.processManualExpose(data);
                    }
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.input = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.invoke("input", data);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.activityInput = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.invoke("activityInput", data);
                    return [2 /*return*/];
                });
            }); });
        });
    };
    EventTracking.prototype.enableAutoExpose = function () {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () {
                _this.exposeService.enable();
                // this.invoke("enableAutoExpose", data);
            });
        });
    };
    EventTracking.prototype.stopExposeMonitor = function () {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () {
                _this.exposeService.stop();
                // this.invoke("stopExposeMonitor", data);
            });
        });
    };
    EventTracking.prototype.reCollectExposeItems = function () {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () {
                _this.exposeService.reCollect();
                // this.invoke("reCollectExposeItems", data);
            });
        });
    };
    /**
     * 下一次收集完成可视区元素后，立即曝光
     */
    EventTracking.prototype.exposeAfterReCollect = function (data) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () {
                // this.invoke("exposeAfterReCollect", data);
                _this.exposeService.exposeAfterReCollect(data);
            });
        });
    };
    EventTracking.prototype.login = function (userId) {
        var _this = this;
        this.delayedInvoke(function () {
            _this.applicationExecutor.callWhenPrepared(function () {
                _this.tracker.sa.login(userId);
            });
        });
    };
    EventTracking.prototype.subscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    EventTracking.prototype.unsubscribe = function (eventType, observer) {
        this.observableService.unsubscribe(eventType, observer);
    };
    EventTracking.prototype.getSaTracker = function () {
        return this.tracker.sa;
    };
    EventTracking.prototype.getBehaviorTracker = function () {
        return this.tracker.behavior;
    };
    EventTracking.prototype.delayedInvoke = function (fn) {
        if (!this.effective) {
            this.pendingInvokes.push(fn);
            return;
        }
        return fn();
    };
    EventTracking.prototype.executePendingInvokes = function () {
        this.pendingInvokes.forEach(function (fn) {
            if (typeof fn === "function") {
                fn();
            }
        });
    };
    EventTracking.prototype.resetPendingInvokes = function () {
        this.pendingInvokes = [];
    };
    EventTracking.prototype.initRouteHooks = function (config) {
        var _a, _b, _c, _d, _e, _f;
        (_c = (_b = (_a = config.common) === null || _a === void 0 ? void 0 : _a.routeHooks) === null || _b === void 0 ? void 0 : _b.leave) === null || _c === void 0 ? void 0 : _c.call(_b);
        (_f = (_e = (_d = config.common) === null || _d === void 0 ? void 0 : _d.routeHooks) === null || _e === void 0 ? void 0 : _e.enter) === null || _f === void 0 ? void 0 : _f.call(_e);
    };
    EventTracking.prototype.updateRouteInfo = function (config) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var current, sessionExpired, transformed_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.getCurrent()];
                    case 1:
                        current = _b.sent();
                        if (!((current === null || current === void 0 ? void 0 : current.uri) !== window.location.href)) return [3 /*break*/, 8];
                        this.v4EventOrderBucket.resetInputOrder();
                        this.saEventOrderBucket.resetInputOrder();
                        this.saEventOrderBucket.resetInputOrders();
                        this.saEventOrderBucket.resetPasteInputs();
                        return [4 /*yield*/, this.sessionService.isExpired()];
                    case 2:
                        sessionExpired = _b.sent();
                        if (!sessionExpired) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.v4EventOrderBucket.resetClickOrder()];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.saEventOrderBucket.resetClickOrder()];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [4 /*yield*/, this.routeStackService.addByType(event_tracking_core_1.RouteType.Change)];
                    case 6:
                        _b.sent();
                        return [4 /*yield*/, this.routeStackService.getCurrent()];
                    case 7:
                        current = _b.sent();
                        _b.label = 8;
                    case 8:
                        if (!current) return [3 /*break*/, 10];
                        if ((_a = config.behavior) === null || _a === void 0 ? void 0 : _a.v4) {
                            transformed_1 = this.transformFieldsService.toFullName([config.behavior.v4])[0];
                            Object.keys(transformed_1).forEach(function (key) {
                                var k = key;
                                if (["screenNum", "screenParam", "screenExtra", "extraInfo"].includes(key) &&
                                    transformed_1[key] &&
                                    current) {
                                    var value = transformed_1[key];
                                    current[k] = value;
                                }
                            });
                        }
                        if (config.sa) {
                            current.saScreenNum = config.sa.page_id;
                        }
                        // 更新最新的当前页面配置
                        return [4 /*yield*/, this.routeStackService.updateCurrent(current)];
                    case 9:
                        // 更新最新的当前页面配置
                        _b.sent();
                        this.applicationExecutor.forceExecute();
                        _b.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    EventTracking.prototype.whenLeave = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // this.resetPendingInvokes();
                    return [4 /*yield*/, this.exposeService.exposeImmediately()];
                    case 1:
                        // this.resetPendingInvokes();
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EventTracking = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObservableService)),
        __param(1, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IBehaviorAdapterService)),
        __param(2, (0, inversify_1.inject)(event_tracking_sensor_analytics_1.TYPES.ISaReportService)),
        __param(3, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor)),
        __param(4, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IRouteStackService)),
        __param(5, (0, inversify_1.inject)(event_tracking_core_1.TYPES.ISessionService)),
        __param(6, (0, inversify_1.inject)(event_tracking_core_1.TYPES.ITransformFieldsService)),
        __param(7, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IAdjustTimeService)),
        __param(8, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IStoreService)),
        __param(8, (0, inversify_1.named)(event_tracking_core_1.TAG.LocalStoreService)),
        __param(9, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IStoreService)),
        __param(9, (0, inversify_1.named)(event_tracking_core_1.TAG.SessionStoreService)),
        __param(10, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IActiveTabService)),
        __param(11, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventObservable)),
        __param(11, (0, inversify_1.named)(event_tracking_core_1.TAG.VisibilityEventService)),
        __param(12, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObserver)),
        __param(12, (0, inversify_1.named)(event_tracking_core_1.TAG.VisibilityEventObserver)),
        __param(13, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventOrderBucket)),
        __param(13, (0, inversify_1.named)(event_tracking_behavior_adapter_1.V4TAG.EventOrderBucket)),
        __param(14, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventOrderBucket)),
        __param(14, (0, inversify_1.named)(event_tracking_sensor_analytics_1.TAG.EventOrderBucket)),
        __param(15, (0, inversify_1.inject)(event_tracking_core_1.TYPES.ILeaveOpsService)),
        __param(16, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IExposeService)),
        __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])
    ], EventTracking);
    return EventTracking;
}());
exports.EventTracking = EventTracking;
